import { BaseTypeahead } from '../interfaces/typeahead';

/** A contract union work-type option. */
export interface ContractUnionWorkType extends BaseTypeahead {
    readonly isUnionWork: boolean;
}

/**
 * Canonical contract union work-type options. This is the single source of
 * truth; `components/contracts/Contract.js` re-exports from here for
 * backward compatibility.
 */
export const ContractUnionWorkTypes: ContractUnionWorkType[] = [
    { value: 1, label: 'None', isUnionWork: false },
    { value: 2, label: 'Distribution (MOU)', isUnionWork: true },
    { value: 3, label: 'Mainline', isUnionWork: true },
    { value: 4, label: 'Heavy Highway', isUnionWork: true },
    { value: 5, label: 'Prevailing Wage', isUnionWork: true },
    { value: 6, label: 'Utility', isUnionWork: true },
    { value: 7, label: 'Distribution (NDA)', isUnionWork: true },
];
